export class LatestNewQuestionModel {
    id: number;
    qno: number;
    qno_en: number;
    qno_te: number;
    qno_ur: number;
    marks: number;
    question_en_id: any;
    question_te_id: any;
    question_ur_id: any;
    question_en: string;
    question_te: string;
    question_ur: string;
    className: string;
    subject_en: string;
    subject_te: string;
    subject_ur: string;
    chapter_en: string;
    chapter_te: string;
    chapter_ur: string;
    language: string;
    isActive: boolean;
    status: string;
    topic: string;
    difficulty: string;
    complexity: string;
    cognitive: string;
    answer_en: string;
    answer_te: string;
    answer_ur: string;
    createdAt: Date;
    updatedAt: Date;

    constructor(data: Partial<LatestNewQuestionModel> = {}) {
        this.id = data.id || 0;
        this.qno = data.qno || 0;
        this.qno_en = data.qno_en || data.qno || 0;
        this.qno_te = data.qno_te || data.qno || 0;
        this.qno_ur = data.qno_ur || data.qno || 0;
        this.marks = data.marks || 0;
        this.question_en_id = data.question_en_id || '';
        this.question_te_id = data.question_te_id || '';
        this.question_ur_id = data.question_ur_id || '';
        this.question_en = data.question_en || '';
        this.question_te = data.question_te || '';
        this.question_ur = data.question_ur || '';
        this.className = data.className || '';
        this.subject_en = data.subject_en || '';
        this.subject_te = data.subject_te || '';
        this.subject_ur = data.subject_ur || '';
        this.chapter_en = data.chapter_en || '';
        this.chapter_te = data.chapter_te || '';
        this.chapter_ur = data.chapter_ur || '';
        this.language = data.language || 'ENGLISH';
        this.isActive = Boolean(data.isActive);
        this.status = data.isActive ? 'Active' : 'Inactive';
        this.topic = data.topic || '';
        this.difficulty = data.difficulty || '';
        this.complexity = data.complexity || '';
        this.cognitive = data.cognitive || '';
        this.answer_en = data.answer_en || '';
        this.answer_te = data.answer_te || '';
        this.answer_ur = data.answer_ur || '';
        this.createdAt = data.createdAt || new Date();
        this.updatedAt = data.updatedAt || new Date();
    }
}